import { useState } from "react";
import FileFullView, { imagetype } from "./FileFullView";
import { GetAccess } from "./RolesandAccess";
import CommonViewMore from "./CommonViewMore";
import {
  DocIcon,
  ImageIcon,
  LoadingImgIcon,
  PdfIcon,
  TxtIcon,
  XlsxIcon,
} from "../assets/icons";
import VideoIcon from "../assets/icons/VideoIcon";

function CommonCardView({
  data = [],
  link,
  fetcher,
  accessString,
  isLoading = true,
  alter_method = false
}) {
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => {
    setShowFile(false);
  };
  const [showData, setShowData] = useState("");
  return (
    <div className="w-full">
      <div className="bg-tabletitle flex items-center h-10">
        <div className="flex items-center justify-end py-3.5 w-full pr-5"></div>
      </div>
      <div className="flex flex-wrap justify-start overflow-y-auto max-h-[calc(100vh-220px)]">
        {isLoading === true ? (
          <>
            {[...Array(33)].map((_, index) => {
              return (
                <div
                  className="w-24 mx-3 mt-4 mb-2 animate-pulse space-y-2 flex flex-col items-center"
                  key={index}
                >
                  <div className="bg-tableodd rounded-lg  flex items-center justify-center w-20 h-20 ">
                    <LoadingImgIcon />
                  </div>
                  <div className="w-full h-3.5 bg-gray-100 rounded-lg "></div>
                </div>
              );
            })}
          </>
        ) : (
          <>
            {data?.data &&
              data?.data?.map((i, index) => (
                <div className="w-24 mx-3 py-1" key={index}>
                  <div className="flex mx-auto">
                    <div
                      className="w-20 h-20 bg-tableodd mx-auto flex justify-center items-center mt-4 mb-2 rounded-lg group relative cursor-pointer"
                      onClick={() => {
                        setShowFile(true);
                        setShowData(i?.image_path);
                      }}
                    >
                      {imagetype.includes(
                        i?.image_path?.split(".").reverse()[0]
                      ) ? (
                        <ImageIcon width="55px" height="55px" />
                      ) : i?.image_path?.split(".").reverse()[0] === "docx" ? (
                        <DocIcon width="65px" height="65px" />
                      ) : i?.image_path?.split(".").reverse()[0] === "doc" ? (
                        <DocIcon width="65px" height="65px" />
                      ) : i?.image_path?.split(".").reverse()[0] === "xlsx" ? (
                        <XlsxIcon width="55px" height="55px" />
                      ) : i?.image_path?.split(".").reverse()[0] === "txt" ? (
                        <TxtIcon width="55px" height="55px" />
                      ) : i?.image_path?.split(".").reverse()[0] === "pdf" ? (
                        <PdfIcon width="65px" height="65px" />
                      ) : i?.image_path?.split(".").reverse()[0] === "mp4" ? (
                        <VideoIcon width="65px" height="65px" />
                      ) : (
                        "No attachment"
                      )}
                      <p className="hidden group-hover:block rounded-lg bg-white shadow-box px-2 text-[10px] absolute top-[42%] left-[14%]">
                        click me
                      </p>
                    </div>
                    {GetAccess(accessString) && (
                      <div className=" pt-3">
                        <CommonViewMore
                          data={i}
                          fetcher={fetcher}
                          link={link}
                          alter_method={alter_method}
                        />
                      </div>
                    )}
                  </div>
                  <div className=" dropdown cursor-pointer relative">
                    <p className="w-24 h-12 text-left text-[10px] break-words line-clamp-3 ">
                      {i?.image_name}
                    </p>
                    <div className="hidden dropdown-menu absolute bottom-2 left-20 z-50 min-w-8 rounded-md bg-white shadow-box max-w-48 text-[11px] p-2">
                      {i?.image_name}
                    </div>
                  </div>
                </div>
              ))}
          </>
        )}
        <FileFullView
          path={showData}
          onClose={handleClose}
          visible={showFile}
        />
      </div>
    </div>
  );
}

export default CommonCardView;
